export default __webpack_public_path__ + "static/image-74deb29ba9d4bffca7f9655b4915ec48.png";